import { default as InfoTip } from './InfoTip';
import { default as InfoTipToggle } from './InfoTipToggle';
import { default as InfoTipMenu } from './InfoTipMenu';
import { default as InfoTipMenuFooter } from './InfoTipMenuFooter';
import { default as InfoTipMenuItemIcon } from './InfoTipMenuItemIcon';

InfoTip.Toggle = InfoTipToggle;
InfoTip.Menu = InfoTipMenu;
InfoTip.MenuItemIcon = InfoTipMenuItemIcon;
InfoTip.MenuFooter = InfoTipMenuFooter;

export { InfoTip, InfoTipToggle, InfoTipMenu, InfoTipMenuItemIcon, InfoTipMenuFooter };


//////////////////
// WEBPACK FOOTER
// ./node_modules/patternfly-react/dist/esm/components/InfoTip/index.js
// module id = 674
// module chunks = 0